import { type LandingTemplate } from "../../template";

export const commonTemplates: LandingTemplate[] = [];
